import React, { useContext, useEffect, useState } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import authContext from '../../context/authContext/authContext';

import { useDispatch, useSelector } from 'react-redux';
import { addAchievementAction } from '../../redux/actions/achievementsAction';
import Loader from '../../utils/Loader';
import RenderError from '../../utils/RenderError';
import { getUsersAction } from '../../redux/actions/userAction';
import { achievementOptions } from '../../utils/utils';

const dataState = {
  partnerId: '',
  event: '',
  achievement: ''
}

const errorState = {
  partnerError: '',
  eventError: '',
  achievementError: '',
  error: ''
}

const initialState = {
  ...dataState,
  ...errorState
};

const AddAchievement = ({ isOpen, toggle, getAchivements, loading }) => {
  const dispatch = useDispatch();
  const { getConfig } = useContext(authContext);
  const config = getConfig();

  const [state, setCompleteState] = useState(initialState)
  const setState = (newState) => setCompleteState((prevState) => ({ ...prevState, ...newState }));

  const { loading: userLoading, users } = useSelector((state) => state.users)

  const getUsers = () => {
    const data = { partnersOnly: true }
    dispatch(getUsersAction(config, data))
  }

  useEffect(() => {
    if (isOpen) {
      getUsers()
    }
  }, [isOpen]);


  const onHideModal = () => {
    setState(initialState)
    toggle();
  }

  const validatePartner = () => {
    if (!state.partnerId) {
      setState({ partnerError: '*Please select a partner' });
    }
  }

  const validateEvent = () => {
    if (!state.event.trim()) {
      setState({ eventError: '*Please enter a valid event' });
    }
  };

  const validateAchievement = () => {
    if (!state.achievement) {
      setState({ achievementError: '*Please select an achievement' });
    }
  };

  const AddAchievement = async () => {
    const { partnerId, event, achievement } = state;
    const data = { partnerId, event, achievement }
    dispatch(addAchievementAction(data, config, getAchivements, onHideModal))
  }


  const handleSubmit = (e) => {
    e.preventDefault();
    const { partnerId, event, achievement } = state;
    if (!partnerId || !event || !achievement) {
      setState({ error: '*Please fill all the required fields' });
      return;
    }

    AddAchievement();
  }

  const closeBtn = () => <button className='btn btn-close' onClick={onHideModal}>X</button>;

  return (
    <Modal isOpen={isOpen} toggle={onHideModal}>
      <ModalHeader toggle={onHideModal} close={closeBtn()}>
        <div className='d-flex align-items-center'>
          <div>Add Achievement</div>
          <div className='ml-3'>
            <Loader isLoading={loading} />
          </div>
        </div>
      </ModalHeader>
      <ModalBody>
        <form onSubmit={handleSubmit}>
          <div class="form-group">
            <label>Partner</label>
            <select
              class="form-control"
              value={state?.partnerId}
              onChange={(e) => setState({ partnerId: e.target.value })}
              onFocus={() => setState({ partnerError: '' })}
              onBlur={validatePartner}
              disabled={loading}
            >
              <option value="">Select Partner</option>
              {users?.map((partner) => (
                <option value={partner._id}>{partner.name} - {partner.email}</option>
              ))}
            </select>
            <RenderError error={state?.partnerError} />
          </div>
          <div class="form-group">
            <label>Event</label>
            <input
              type="text"
              class="form-control"
              value={state?.event}
              onChange={(e) => setState({ event: e.target.value })}
              onFocus={() => setState({ eventError: '' })}
              onBlur={validateEvent}
              disabled={loading}
            />
            <RenderError error={state?.eventError} />
          </div>
          <div class="form-group">
            <label>Achievement</label>
            <select
              class="form-control"
              value={state?.achievement}
              onChange={(e) => setState({ achievement: e.target.value })}
              onFocus={() => setState({ achievementError: '' })}
              onBlur={validateAchievement}
              disabled={loading}
            >
              {achievementOptions.map((option) => (
                <option value={option.value}>{option.label}</option>
              ))}
            </select>
            <RenderError error={state?.achievementError} />
          </div>
          <RenderError error={state?.error} />
        </form>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={onHideModal} disabled={loading}>
          Cancel
        </Button>
        <Button color="gleamdesk-blue gleamdesk-orange" onClick={handleSubmit} disabled={loading}>
          Add Product
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default AddAchievement